import { mapValues } from 'lodash-es';
import { TinyEmitter } from 'tiny-emitter';
export class State {
    emitter;
    value;
    name;
    constructor(value, name) {
        this.emitter = new TinyEmitter();
        this.value = value;
        this.name = name;
    }
    toggleListener(add, callback, context) {
        if (add)
            return this.listen(callback, context);
        else
            return this.unlisten(callback);
    }
    listenAndStart(callback, context) {
        this.listen(callback, context);
        callback(this.value, this.value);
    }
    listen(callback, context) { this.emitter.on('', callback, context); }
    listenOnce(callback, context) { this.emitter.once('', callback, context); }
    unlisten(callback) {
        this.emitter.off('', callback);
    }
    destroy() { this.unlisten(); }
    set(value, force) {
        if (!force && this.value === value)
            return;
        const previous = this.value;
        this.value = value;
        this.emitter.emit('', value, previous);
    }
    get() { return this.value; }
}
export function createStore(state) {
    let emitters = {};
    for (const k in state)
        emitters[k] = new State(state[k], k);
    emitters = Object.freeze(emitters);
    return emitters;
}
export function exportStore(store) {
    return mapValues(store, (v) => v.get());
}
export default createStore;
